import { t } from 'services/i18n.service';
import { HabitPackType } from 'interfaces/common.interface';
import { useAppDispatch } from 'store/hooks';
import { setCurrentViewedPack } from 'store/reducer//habit-pack/slice';
import ExpandableSection from 'components/ui/ExpandableSection';
import BaseButton from 'components/ui/BaseButton';

export interface HabitPackCardProps {
  habitPack: HabitPackType;
}

export default function HabitPackCard({ habitPack }: HabitPackCardProps) {
  const dispatch = useAppDispatch();

  const shortDescription =
    habitPack?.description_plain_text ||
    habitPack?.description ||
    t('market.no_description_available');

  return (
    <ExpandableSection
      wrapperStyles='shadow-sm  sm:shadow-md shrink-0'
      headerTitleStyles='w-full'
      title={
        <div className='w-full flex flex-col gap-1'>
          <div className='w-full flex items-center justify-between'>
            <p className='flex-1 text-left capitalize ~text-xs/sm line-clamp-1 pr-2'>
              {habitPack?.pack_name ?? ''}
            </p>
          </div>
          <p className='w-full flex items-center gap-1.5 text-xs'>
            {t('market.made_by')}
            <span className='dark:text-primary-dark-500 font-normal sm:font-semibold truncate'>
              {habitPack?.creator_name ?? ''}
            </span>
          </p>
        </div>
      }>
      <div className='px-1 py-2'>
        <p className='text-xs sm:text-sm text-gray-700 dark:text-gray-300 mb-3'>
          {shortDescription}
        </p>
        <BaseButton
          size='xs'
          onClick={(event) => {
            event.stopPropagation();
            dispatch(setCurrentViewedPack(habitPack));
          }}
          title={t('market.view_more_details')}
          additionalStyles='w-full'
          variant='secondary'
        />
      </div>
    </ExpandableSection>
  );
}
